import {
    actionCreator,
    checkHttpStatus, 
    jsonApiHeader, 
    showErrorMessage, 
    showSuccessMessage, 
    showWarningMessage,
    NotesActionTypes, 
    GET_NOTES_LIST_API, 
    POST_NOTES_API, 
    DELETE_NOTES_API,
    GET_NOTES_DETAIL_API,
    POST_MARKEDASREVIEWED_NOTES_API
} from '../constants/ApiConstants';

import Alert from 'react-s-alert';
import { createSearchUrlForCustomAPI } from '../../../../../../../actions/utilAction';

export const NotesList = (searchObj, patientId) => {
    let query_params = createSearchUrlForCustomAPI(searchObj);
    return (dispatch, getState) => {
        dispatch(actionCreator(NotesActionTypes.get_notesList.REQUEST));
        fetch(`${GET_NOTES_LIST_API}${query_params}&patientId=${patientId}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(NotesActionTypes.get_notesList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(NotesActionTypes.get_notesList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_notesList', error);
            });
    };
};

export const NotesListDetails = (noteId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(NotesActionTypes.get_notesDetail.REQUEST));
        fetch(`${GET_NOTES_DETAIL_API}?noteId=${noteId}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(NotesActionTypes.get_notesDetail.SUCCESS, response));
                } else {
                    dispatch(actionCreator(NotesActionTypes.get_notesDetail.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_notesDetail', error);
            });
    };
};

export const saveNotes = (formProps) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(NotesActionTypes.save_Notes.REQUEST));
        fetch(`${POST_NOTES_API}`, {
            method: 'POST',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
            body: JSON.stringify(formProps),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(NotesActionTypes.save_Notes.SUCCESS, response));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(NotesActionTypes.save_Notes.SUCCESS, null));
                }
            })
            .catch(function (error) {
                console.log('error save_Notes', error);
            });
    };
};

export const deleteNotes = (noteId, patientId) => {
    Alert.closeAll();
    return (dispatch, getState) => {
        dispatch(actionCreator(NotesActionTypes.delete_Notes.REQUEST));
        fetch(`${DELETE_NOTES_API}?noteId=${noteId}`, {
            method: 'PATCH',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then((response) => {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(NotesActionTypes.delete_Notes.SUCCESS, response));
                    let searchObj = {
                        sort_fields: '',
                        sort_order: '',
                        contain_filters: { SearchText:  null },
                        pageNumber: 1,
                    };
                    dispatch(NotesList(searchObj, patientId))
                } else if (response.statusCode === 401 || response.statusCode === 422) {
                    showWarningMessage(response.message);
                    dispatch(actionCreator(NotesActionTypes.delete_Notes.SUCCESS, null));
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(NotesActionTypes.delete_Notes.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error delete_Notes', error);
            });
    };
};


export const MarkedAsReviewPatientNote = (noteId, patientId) => {
    Alert.closeAll();
    return (dispatch, getState) => {
        dispatch(actionCreator(NotesActionTypes.markedAsReviewed_Notes.REQUEST));
        fetch(`${POST_MARKEDASREVIEWED_NOTES_API}?noteId=${noteId}`, {
            method: 'POST',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then((response) => {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    showSuccessMessage(response.message);
                    dispatch(actionCreator(NotesActionTypes.markedAsReviewed_Notes.SUCCESS, response));
                    let searchObj = {
                        sort_fields: '',
                        sort_order: '',
                        contain_filters: { SearchText:  null },
                        pageNumber: 1,
                    };
                    dispatch(NotesList(searchObj, patientId))
                } else {
                    showErrorMessage(response.message);
                    dispatch(actionCreator(NotesActionTypes.markedAsReviewed_Notes.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error markedAsReviewed_Notes', error);
            });
    };
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/Notes/actions/notesActions.js